import React, { useEffect } from 'react';
import "../register.css";
import { AuthContext } from "../../AuthContext";
import * as BsIcons from "react-icons/bs";
import { IconName } from "react-icons/gr";
import { AlignCenter, EnvelopeFill, Phone, Telephone } from 'react-bootstrap-icons';
import { Tab, Table } from 'react-bootstrap';
import { getAPI } from '../GdacsAPI';
import { useViewPort } from '../Hooks/useViewPort';

const TableRowService = (props) => {
    const authContext = React.useContext(AuthContext);
    const params = props.params;
    const [services, setServices] = React.useState(params?.services.map((a, i) => ({ ...a, id: i })) ?? []);
    const { width } = useViewPort();
    const breakpoint = 520;


    return (
        <>
            <Table id="reacpUser" className="table_recapUser" >
                <thead>
                    {breakpoint < width &&
                        <th style={{ width: "20%" }}>Event Types</th>
                    }
                    {breakpoint > width &&
                        <th style={{ width: "10%" }}>Event</th>
                    }
                    <th style={{ width: "20%" }}>Channel</th>
                    <th style={{ width: "20%" }}>Region</th>
                    {breakpoint < width &&
                        <th style={{ width: "20%" }}>Language</th>                  
                    }
                    {breakpoint > width &&
                        <th style={{ width: "10%" }}>Lang</th>
                    }
                    <th style={{ width: "10%" }}>Night</th>
                    {breakpoint < width &&
                        <th style={{ width: "20%" }}>Enable</th>
                    }
                    {breakpoint > width &&
                        <th style={{ width: "10%" }}>Enable</th>
                    }
                </thead>
                <tbody>
                    {
                        services.map((service) => {
                            return <tr><ServiceRow service={service} /></tr>
                        })
                    }
                </tbody>
            </Table>
        </>
    )
}

const ServiceRow = (props) => {
    const [servicestypes, setServicesTypes] = React.useState([]);
    const [regions, setRegions] = React.useState([]);
    const [servicestypesdevice, setServicesTypesDevice] = React.useState([]);
    const [language, setLanguage] = React.useState([]);
    const [eventtypes, setEventTypes] = React.useState([]);
    const { width } = useViewPort();
    const breakpoint = 520;

    async function GetServicesTypes() {
        var url = getAPI() + `api/register/Definition/servicetype/`;
        const response = await fetch(url);
        if (!response.ok) {
            setServicesTypes('Failed to retreive services types data.');
            return;
        }
        const servicesTypesData = await response.json();
        if (servicesTypesData) {
            setServicesTypes(servicesTypesData);
            setServicesTypesDevice(servicesTypesData);
            setLanguage(servicesTypesData[1].listLanguages);
        }
    }

    async function GetRegions() {
        var url = getAPI() + `api/register/Definition/regions/`;
        const response = await fetch(url);
        if (!response.ok) {
            setRegions('Failed to retreive regions data.');
            return;
        }
        const regionsData = await response.json();
        if (regionsData) {
            setRegions(regionsData);
        }
    }

    async function GetEventTypes() {
        var url = getAPI() + `api/register/Definition/eventtypes/`;
        const response = await fetch(url);
        if (!response.ok) {
            setEventTypes('Failed to retreive event types data.');
            return;
        }
        const eventtypesData = await response.json();
        if (eventtypesData) {
            setEventTypes(eventtypesData);
        }
    }


    React.useEffect(() => {
        GetServicesTypes();
        GetRegions();
        GetEventTypes();
    }, []);;

    return (
        <>
            <td className="cell_alerts" style={{ textAlign: "center" }} key={props.service.eventType}>
                {props.service.eventType === "NL" ?
                    <img src={`Images/NL_Blue.png`} style={{ width: "20px", height: "20px" }} /> :
                    <img src={`Images/gdacs_icons/alerts/${props.service.alertLevel}/${props.service.eventType}.png`} style={{ width: "20px", height: "20px" }} />
                }   
            </td>
            {servicestypesdevice.filter(item => item.idServiceType === props.service.idServiceType).map(types => (
                <td className="cell_alerts" key={types.idServiceType} style={{ textAlign: "center" }}>
                    {types.idServiceType === 1 ?
                        <EnvelopeFill color="#0099CC" size={18} />
                        : types.idServiceType === 3 ? <Telephone color="#0099CC" size={18} />
                            : <Phone color="#0099CC" size={18} />
                    }
                </td>
            ))}
            {
                regions.filter(item => item.idRegion === props.service.region).map(reg => (
                    <td className="cell_alerts" key={reg.idregion}>{reg.regionName}</td>
                ))}
            {
                language.filter(item => item.key === props.service.language).map(lang => (
                    <td className="cell_alerts" key={lang.key}>{breakpoint < width ? lang.value : lang.key.toUpperCase()}</td>
                ))
            }
            <td className="cell_alerts" style={{ textAlign: "center" }}>
                {
                    props.service.stopNight === true ? <BsIcons.BsCheck color="#044257" size={18} /> : <></>
                }
            </td>
            <td className="cell_alerts" style={{ textAlign: "center" }}>
                {
                    props.service.enabled === true ? <BsIcons.BsCheck color="#0099CC" size={18} /> : <></>
                }
            </td>
        </>
    )
}

export { TableRowService };